import React, { useId } from 'react';

interface ToggleRowProps {
    label: string;
    description?: string;
    checked: boolean;
    disabled?: boolean;
    onChange: () => void;
}

const ToggleRow: React.FC<ToggleRowProps> = ({
    label,
    description = '',
    checked,
    disabled,
    onChange
}) => {
    const descriptionId = useId();

    return (
        <div className="flex items-center justify-between py-1">
            <div className="flex flex-col gap-1">
                <span className="text-sm font-semibold text-gray-800">{label}</span>
                {description && (
                    <span id={descriptionId} className="text-sm text-gray-500">
                        {description}
                    </span>
                )}
            </div>
            <button
                role="switch"
                aria-checked={checked}
                aria-label={label}
                aria-describedby={description ? descriptionId : undefined}
                onClick={onChange}
                disabled={disabled}
                className={`relative inline-flex items-center h-6 w-11 shrink-0 rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                    disabled
                        ? 'cursor-not-allowed bg-gray-200 opacity-50 focus:ring-gray-300'
                        : checked
                          ? 'cursor-pointer bg-gray-800 hover:bg-gray-900 focus:ring-gray-500'
                          : 'cursor-pointer bg-gray-200 hover:bg-gray-300 focus:ring-gray-400'
                }`}
            >
                <span
                    className={`pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow-md transition-transform duration-200 ease-in-out ${
                        checked ? 'translate-x-[1.375rem]' : 'translate-x-0.5'
                    }`}
                />
            </button>
        </div>
    );
};

export default ToggleRow;
